<template>
  <div>
    Enter position range:
               <el-input
                  style="width:150px;margin-top: 35px; "
                  :rows="1"
                  placeholder="start"
                  resize=none
                  v-model="startText"
                  clearable>
               </el-input>
               <span> - </span>
               <el-input
                  style="width:150px;margin-top: 35px; "
                  :rows="1"
                  placeholder="end"
                  v-model="endText"
                  resize=none
                  clearable>
               </el-input>&nbsp bp &nbsp 
               <el-button type="warning" @click="locate()">Locate</el-button>
    <div id="myChart" :style="{ width: '100%', height: '500px' }"></div>
</div>
  
</template>

<script>
var myChart;
export default {
    data(){
      return{
        startText:0,
        endText:100000000
      }
   
    },
  props:{
    plotData:Array,
  },
  mounted() {
    this.drawLine();
  },
  watch: {
    plotData: function () {
      this.drawLine();
    },
  },
  methods: {
    drawLine() {
      // 如果已存在视图实例，则先销毁后创建
      if (myChart != null && myChart != "" && myChart != undefined) {
        myChart.dispose();
      }
      // 基于准备好的dom，初始化echarts实例
      myChart = this.echarts.init(document.getElementById("myChart"));
      var color_dict = {
        gene: "#7b9ce1",
        snp: "#bd6d6c",
        rna: "#75d874",
        methy: "#e0bc78",
      };

      var categories = [ "SNP", "Gene","RNA", "Methylation"];
      var option;
      
      var renderItem = (params, api) => {
        var categoryIndex = api.value(0);
        var start = api.coord([api.value(1), categoryIndex]);
        var end = api.coord([api.value(2), categoryIndex]);
        var height = api.size([0, 1])[1] * 0.5;
        var tmpwidth;
        if(categoryIndex==0) tmpwidth=api.coord([api.value(2)+10000,categoryIndex])[0]-api.coord([api.value(1)-10000, categoryIndex])[0]
        else tmpwidth=end[0] - start[0]
        var rectShape = this.echarts.graphic.clipRectByRect(
          {
            x: start[0],
            y: start[1] - height / 2,
            width: tmpwidth,
            height: height,
          },
          {
            x: params.coordSys.x,
            y: params.coordSys.y,
            width: params.coordSys.width,
            height: params.coordSys.height,
          }
        );
        return (
          rectShape && {
            type: "rect",
            transition: ["shape"],
            shape: rectShape,
            style: api.style(),
          }
        );
      };
      option = {
        tooltip: {
          formatter: function (params) {
            if ("allele" in params.data) {
              return (
                params.marker +
                "SNP ID : " +
                params.data.name +
                "<br/>Position : " +
                params.data.value[1] +
                "<br/>Allele : " +
                params.data.allele +
                "<br/>Gene name : " +
                params.data.gene
              );
            } else if ("type" in params.data) {
              return (
                params.marker +
                "Gene ID : " +
                params.data.id +
                "<br/>Gene Name : " +
                params.name +
                "<br/>Start : " +
                params.data.value[1] +
                "<br/>End : " +
                params.data.value[2] +
                "<br/>Map Location : " +
                params.data.location +
                "<br/>Gene type : " +
                params.data.type
              );
            }else if("probe" in params.data){
              if(params.data.gene_location!=null){
                return (
                  params.marker +
                  "Gene ID : " +
                  params.data.id +
                  "<br/>Gene Name : " +
                  params.name +
                  "<br/>Probe : " +
                  params.data.probe +
                  "<br/>Start : " +
                  params.data.value[1] +
                  "<br/>End : " +
                  params.data.value[2] +
                  "<br/>Map Location : " +
                  params.data.location
                );
              }else{
                return(
                  params.marker +
                  "Gene ID : " +
                  params.data.id +
                  "<br/>Gene Name : " +
                  params.name +
                  "<br/>Probe : " +
                  params.data.probe +
                  "<br/>Probe position : " +
                  (params.data.value[1]+10000)+
                  "<br/>Map Location : " +
                  params.data.location
                )
              }
            }else{
              return (
                params.marker +
                "Gene ID : " +
                params.data.id +
                "<br/>Gene Name : " +
                params.name +
                "<br/>Probe : " +
                params.data.probe +
                "<br/>Start : " +
                params.data.value[1] +
                "<br/>End : " +
                params.data.value[2] +
                "<br/>Map Location : " +
                params.data.location
              );
            }
            // return params.marker + params.name + ": " + params.value[3] + " ms";
          },
        },
        dataZoom: [
          {
            type: "slider",
            filterMode: "weakFilter",
            showDataShtadow: false,
            top: 400,
            labelFormatter: "",
            startValue: this.startText,
            endValue: this.endText,
          },
          {
            type: "inside",
            filterMode: "weakFilter"
          },
        ],
        grid: {
          height: 300,
        },
        xAxis: {
          min: 0,
          scale: true,
          axisLabel: {
            formatter: function (val) {
              return Math.max(0, val - 0) + " bp";
            },
          },
        },
        yAxis: {
          data: categories,
        },
        series: [
          {
            type: "custom",
            renderItem: renderItem,
            itemStyle: {
              opacity: 0.8,
            },
            encode: {
              x: [1, 2],
              y: 0,
            },
            data: this.plotData,
          },
        ],
      };
      myChart.on('click',params=> { 
        this.$emit('click',params.data);
      }); 
      option && myChart.setOption(option);
    },
    locate(){
      this.drawLine();
    }
  },
};
</script>
